export const FETCH_CONTACT_BEGIN = 'FETCH_CONTACT_BEGIN'
export const FETCH_CONTACT_SUCCESS = 'FETCH_CONTACT_SUCCESS'
export const FETCH_CONTACT_FAILED = 'FETCH_CONTACT_FAILED'
